export default __webpack_public_path__ + "static/media/red.cc040b9b.png";